import * as React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentTab } from '../../selectors/tabs';
import { ETabs } from '../../types/redux/tabs';
import { getNewPageAgencies, getNewPageRealtors } from '../../actions/pagination';

/**
 * Хук возвращает нужный апи хелпер для листинга, в зав-ти от текущего выбранного таба
 * */
export const useGetListingHandler = () => {
  const currentTab = useSelector(getCurrentTab);

  return React.useMemo(() => {
    const isRealtorsListing = currentTab === ETabs.Realtors;

    return isRealtorsListing ? getNewPageRealtors : getNewPageAgencies;
  }, [currentTab]);
};
